"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _hooks = require("@datepicker-react/hooks");
var _clsx = _interopRequireDefault(require("clsx"));
var _dayjs = _interopRequireDefault(require("dayjs"));
var _isBetween = _interopRequireDefault(require("dayjs/plugin/isBetween"));
var _index = _interopRequireDefault(require("./index.style"));
var _datepickerContext = _interopRequireDefault(require("../datepickerContext"));
var _dates = require("../../../utils/dates");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Day = props => {
  const classes = (0, _index.default)();
  const {
    day,
    dayType,
    date
  } = props;
  const dayRef = (0, _react.useRef)(null);
  _dayjs.default.extend(_isBetween.default);
  const {
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateSelect,
    onDateFocus,
    onDateHover,
    start,
    end,
    incomingStartDate,
    incomingEndDate
  } = (0, _react.useContext)(_datepickerContext.default);
  const {
    isSelected,
    disabledDate,
    onClick,
    onKeyDown,
    onMouseEnter,
    tabIndex
  } = (0, _hooks.useDay)({
    date,
    focusedDate,
    isDateFocused,
    isDateSelected,
    isDateHovered,
    isDateBlocked,
    isFirstOrLastSelectedDate,
    onDateFocus,
    onDateSelect,
    onDateHover,
    dayRef
  });
  const getDayType = () => {
    if ((0, _dates.compareDays)(start, date)) {
      return 'start';
    }
    if ((0, _dates.compareDays)(end, date)) {
      return 'end';
    }
    if (disabledDate) {
      return 'disabled';
    }
    if (isSelected) {
      return 'inRange';
    }
    return 'enabled';
  };
  const dayTypeVal = dayType || getDayType();
  const shouldHaveUnderscore = (0, _dayjs.default)(date).isBetween((0, _dayjs.default)(incomingStartDate), (0, _dayjs.default)(incomingEndDate), null, '[]');
  const isBetweenIncomingDates = (0, _dayjs.default)(date).isBetween((0, _dayjs.default)(incomingStartDate).add(1, 'days'), (0, _dayjs.default)(incomingEndDate).subtract(1, 'days'), null, '[]');
  const getEvent = event => {
    if (isBetweenIncomingDates) {
      return () => {};
    }
    return event;
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.dayWrapper, "wrapper-type-".concat(dayTypeVal), (isBetweenIncomingDates || disabledDate) && 'wrapper-type-not-selectable')
  }, /*#__PURE__*/_react.default.createElement("button", {
    "data-testid": "test-id-".concat(dayTypeVal),
    onClick: getEvent(onClick),
    onKeyDown: getEvent(onKeyDown),
    onMouseEnter: getEvent(onMouseEnter),
    tabIndex: tabIndex,
    type: "button",
    ref: dayRef,
    className: (0, _clsx.default)(classes.dayButton, "button-type-".concat(dayTypeVal), (isBetweenIncomingDates || disabledDate) && 'button-type-not-selectable')
  }, day, " ", shouldHaveUnderscore ? /*#__PURE__*/_react.default.createElement("div", {
    className: classes.underscore
  }) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)));
};
Day.propTypes = {
  day: _propTypes.default.string,
  dayType: _propTypes.default.string,
  date: _propTypes.default.instanceOf(Date)
};
Day.defaultProps = {
  day: '',
  dayType: '',
  date: new Date()
};
var _default = exports.default = Day;